module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/team/team-admin.component.css
// module id = ./src/app/admin/team/team-admin.component.css
// module chunks = main